import { useMutation, useQueryClient } from '@tanstack/react-query';
import { leaderboardKeys } from '../leaderboard/leaderboard.keys';
import { retrySprintDistribution } from './payout.service';
export const useRetrySprintDistribution = ({ subdomain, onSuccess, onError, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => retrySprintDistribution(subdomain, data),
        onSuccess: async (data, variables) => {
            // Invalidate sprints to refresh the rewardDistributed status
            await queryClient.invalidateQueries({
                queryKey: leaderboardKeys.sprints(subdomain),
            });
            // Invalidate the specific sprint data if it's cached
            await queryClient.invalidateQueries({
                queryKey: leaderboardKeys.sprints(subdomain, variables.sprintId),
            });
            onSuccess?.(data);
        },
        onError: (error) => {
            onError?.(error);
        },
    });
};
